import { GenUtil } from "../../base/cutil/GenUtil";
import { Lazyload } from "../../base/cutil/Lazyload";
import { ReadyStatus } from "../../base/cutil/ReadyStatus";
import { StoreBase } from "../../base/cutil/StoreBase";
import { ImagicaCreatorPlan } from "../webconfig/domain/ImagicaCreatorPlan";
import { JsonUtil } from "../../base/cutil/JsonUtil";
import { ImagicaFeature } from "../webconfig/domain/ImagicaFeature";
import webConfigLocal from "../webconfig/domain/WebConfigLocal.json";
import { ImagicaPublishSetting } from "../webconfig/domain/ImagicatPublishSetting";
import { StaticLinksType } from "../webconfig/domain/StaticLinksType";
import { ImagicaTermsPopup } from "../webconfig/domain/ImagicaTermsPopup";
export class WebConfigState {
    constructor() {
        this.response = {};
        /**
         * 数据加载状态
         */
        this.readyStatus = ReadyStatus.PENDING;
        /**
         * 第一次加载，用于做骨架屏
         */
        this.initLoading = true;
        /**
         * 是否禁用了 templates
         */
        this.disabled = true;
        // other data
        this.templates = [];
        this.exampleVideos = [];
        this.cot = {};
        this.functionGroupConfig = [];
        this.imagica_creator_stripe_subscription_management_link = "";
        this.imagica_creator_subscribe_success = [];
        this.imagica_creator_plans = [];
        this.imagica_features = [];
        this.imagicaAppTemplates = [];
        this.imagicaAppfonts = [];
        this.imagicaCreatorDowngradePlanPopup = {};
    }
}
export class WebConfigStore extends StoreBase {
    constructor(fotClient) {
        super(() => new WebConfigState());
        this.fotClient = fotClient;
        this.lazyload = new Lazyload(() => {
            const state = GenUtil.copyWith(new WebConfigState(), this.state, { readyStatus: true });
            this.emit(state);
            return this.fotClient.webConfigApi.fetchWebConfig().then(x => {
                /// subscription 相关
                const imagica_creator_stripe_subscription_management_link = x.studios.imagica_creator_stripe_subscription_management_link ||
                    webConfigLocal.studios.imagica_creator_stripe_subscription_management_link;
                const imagica_creator_subscribe_success = x.studios.imagica_creator_subscribe_success || webConfigLocal.studios.imagica_creator_subscribe_success;
                const imagica_creator_plans = JsonUtil.toArrayFromType(ImagicaCreatorPlan, x.studios.imagica_creator_plans || webConfigLocal.studios.imagica_creator_plans) || [];
                const imagica_features = JsonUtil.toArrayFromType(ImagicaFeature, x.studios.imagica_features || webConfigLocal.studios.imagica_features) || [];
                const templates = x.studios.templates || webConfigLocal.studios.templates;
                const exampleVideos = x.studios.example_videos || webConfigLocal.studios.example_videos;
                const cot = x.studios.cot || webConfigLocal.studios.cot;
                const functionGroupConfig = x.studios.function_group_config || webConfigLocal.studios.function_group_config;
                const imagicaAppTemplates = x.studios.imagica_app_templates || webConfigLocal.studios.imagica_app_templates;
                const imagicaAppfonts = x.studios.imagica_app_fonts || webConfigLocal.studios.imagica_app_fonts;
                const imagicaCreatorDowngradePlanPopup = x.studios.imagica_creator_downgrade_plan_popup || webConfigLocal.studios.imagica_creator_downgrade_plan_popup;
                const imagica_publish_setting = JsonUtil.toModelFromType(ImagicaPublishSetting, x.studios.imagica_publish_setting?.link || webConfigLocal.studios.imagica_publish_setting);
                const static_links = JsonUtil.toModelFromType(StaticLinksType, x.studios.static_links || webConfigLocal.studios.static_links);
                const imagica_terms_popup = JsonUtil.toModelFromType(ImagicaTermsPopup, x.studios.imagica_terms_popup || webConfigLocal.studios.imagica_terms_popup);
                console.log("setting: setting");
                const state = GenUtil.copyWith(new WebConfigState(), this.state, {
                    response: x,
                    readyStatus: false,
                    initLoading: false,
                    imagica_creator_stripe_subscription_management_link,
                    imagica_creator_subscribe_success,
                    imagica_creator_plans,
                    imagica_features,
                    templates,
                    exampleVideos,
                    cot,
                    functionGroupConfig,
                    imagicaAppTemplates,
                    imagicaAppfonts,
                    imagicaCreatorDowngradePlanPopup,
                    imagica_publish_setting,
                    static_links,
                    imagica_terms_popup,
                });
                this.emit(state);
                return state;
            });
        });
    }
    async renew() {
        return this.lazyload.renew();
    }
    async get() {
        return this.lazyload.get();
    }
    async templates() {
        return await this.get().then(x => x.templates);
    }
    async exampleVideos() {
        return await this.get().then(x => x.exampleVideos);
    }
    async cot() {
        return await this.get().then(x => x.cot);
    }
    async functionGroupConfig() {
        return await this.get().then(x => x.functionGroupConfig);
    }
    async stripeManagementLink() {
        return this.get().then(x => x.imagica_creator_stripe_subscription_management_link);
    }
    async subscribeSuccessContent() {
        return this.get().then(x => x.imagica_creator_subscribe_success);
    }
    async imagicaCreatorPlans() {
        return this.get().then(x => x.imagica_creator_plans);
    }
    async imagicaFeatures() {
        return this.get().then(x => x.imagica_features);
    }
    async imagicaAppTemplates() {
        return await this.get().then(x => x.imagicaAppTemplates);
    }
    async imagicaAppfonts() {
        return await this.get().then(x => x.imagicaAppfonts);
    }
    async imagicaCreatorDowngradePlanPopup() {
        return this.get().then(x => x.imagicaCreatorDowngradePlanPopup);
    }
}
